// =============================
// Email: info@xx.com
// www.xx.com/templates
// =============================

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { EndpointBase } from './endpoint-base.service';
import { ConfigurationService } from './configuration.service';


@Injectable()
export class SFDataEndpoint extends EndpointBase {

  get GetIDPReportUrl() { return this.configurations.baseUrl + '/api/SF/GetIDPReport'; }

  get GetEmailsUrl() { return this.configurations.baseUrl + '/api/SF/GetEmails'; }

  
  get GetCPReportUrl() { return this.configurations.baseUrl + '/api/SF/GetCPReport'; }
  get GetCMReportUrl() { return this.configurations.baseUrl + '/api/SF/GetCMReport'; }
  get GetCampaignContactsUrl() { return this.configurations.baseUrl + '/api/SF/GetCampaignContacts'; }
  get GetRetailsUrl() { return this.configurations.baseUrl + '/api/SF/GetRetails'; }
  get GetAddInfoDDsUrl() { return this.configurations.baseUrl + '/api/SF/GetAddInfoDDs'; }
  get GetAccountHubsUrl() { return this.configurations.baseUrl + '/api/SF/GetAccountHubs'; }
  get HubReportUploadUrl() { return this.configurations.baseUrl + '/api/SFHubReport/Upload'; }
  get HubReportMissingUrl() { return this.configurations.baseUrl + '/api/SFHubReport/Missing'; }
  get HubReportContextUrl() { return this.configurations.baseUrl + '/api/SFHubReport/Context'; }
  get GetAccountRepsUrl() { return this.configurations.baseUrl + '/api/SF/GetAccountReps'; }
  get GetCheckDueDeligRequiredUrl() { return this.configurations.baseUrl + '/api/SF/GetCheckDueDeligRequired'; }

  get GetReSendEmailUrl() { return this.configurations.baseUrl + '/api/SF/GetReSendEmail'; }

  get ResendEmailLogUrl() { return this.configurations.baseUrl + '/api/SF/ResendEmailLog'; }

  
  get GetCheckDueDeligRequiredMyOwnOfficeUrl() { return this.configurations.baseUrl + '/api/SF/GetCheckDueDeligRequiredMyOWnOffice'; }
  
  get GetCaseDataurl() { return this.configurations.baseUrl + '/api/SF/GetCaseData'; }
  get GetCDReportUrl() { return this.configurations.baseUrl + '/api/SF/GetCDReport'; }
  get CreateICDurl() { return this.configurations.baseUrl + '/api/SF/CreateICD'; }
  get CreateICDStep2url() { return this.configurations.baseUrl + '/api/SFStep2/Create'; }
  get CreateICDStep3url() { return this.configurations.baseUrl + '/api/SFStep3/Create'; }
  get CreateICDAddloc3url() { return this.configurations.baseUrl + '/api/SFStep3/AddLoc'; }
  get CreateOffBoardurl() { return this.configurations.baseUrl + '/api/SFStep3/OffBoardICD'; }
  
  get CreateCampChange3url() { return this.configurations.baseUrl + '/api/SFStep3/ChangeCamp'; }
  get CreateICDCloseurl() { return this.configurations.baseUrl + '/api/SFStep3/CloseICD'; }
  get ChangeOfficeInfourl() { return this.configurations.baseUrl + '/api/SFStep3/ChangeOffcInfo'; }
  get HubMaintainurl() { return this.configurations.baseUrl + '/api/SFStep3/HubMaintain'; }
  
  get CreateMoveLocurl() { return this.configurations.baseUrl + '/api/SFStep3/MoveLoc'; }
  get CreateInactiveOffurl() { return this.configurations.baseUrl + '/api/SFStep3/InActiveOffice'; }
  
  get CreateReOpencurl() { return this.configurations.baseUrl + '/api/SFStep3/ReOpen'; }
  get CreateICDStep4url() { return this.configurations.baseUrl + '/api/SFStep3/Create4'; }
  get GetICDsurl() { return this.configurations.baseUrl + '/api/SFStep2/GetICD'; }
  
  get GetOTPsurl() { return this.configurations.baseUrl + '/api/SFStep3/GetOTP'; }
  get GetICDStep3surl() { return this.configurations.baseUrl + '/api/SFStep3/GetICD'; }
  get GetICDStep3byAccsurl() { return this.configurations.baseUrl + '/api/SFStep3/GetICDByAccount'; }
  get GetICDStep3byAccsjdeurl() { return this.configurations.baseUrl + '/api/SFStep3/GetICDByAccountJDE'; }
  get GetICDLocationsByAccounturl() { return this.configurations.baseUrl + '/api/SFStep3/GetICDLocationsByAccount'; }
  get MasterConfigsurl() { return this.configurations.baseUrl + '/api/Customer/MasterConfigstypes'; }
  get LoginSFurl() { return this.configurations.baseUrl + '/api/SF/SFLogin'; }
  get GetUsersUrl() { return this.configurations.baseUrl + '/api/account/users'; }
  get SendComposedEmailUrl() { return this.configurations.baseUrl + '/api/SFEmailComposition/SendComposedEmail'; }
  get DocumentVerifyUrl() { return this.configurations.baseUrl + '/api/DocumentVerification/verify'; }
  get StageAttachmentUrl() { return this.configurations.baseUrl + '/api/SFStep3/StageAttachment'; }
  // Step 2 (icdinfo) is an anonymous emailed-link flow, so it uses the [AllowAnonymous] endpoint on SFStep2.
  get StageAttachmentStep2Url() { return this.configurations.baseUrl + '/api/SFStep2/StageAttachment'; }
  get GetDashboardStatsUrl() { return this.configurations.baseUrl + '/api/SF/GetDashboardStats'; }
  get CheckTaxIdUrl() { return this.configurations.baseUrl + '/api/SF/CheckTaxId'; }
  get GetAddressChangeTasksUrl() { return this.configurations.baseUrl + '/api/SF/GetAddressChangeTasks'; }
  get HelpfulContactsUrl() { return this.configurations.baseUrl + '/api/Admin/HelpfulContacts'; }



  constructor(private configurations: ConfigurationService, http: HttpClient, authService: AuthService) {
    super(http, authService);
  }

   


  getIDPReportEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetIDPReportUrl}/${page}/${pageSize}` : this.GetIDPReportUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIDPReportEndpoint(page, pageSize));
      }));
  }

  getEmails<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetEmailsUrl}/${page}/${pageSize}` : this.GetEmailsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIDPReportEndpoint(page, pageSize));
      }));
  }

  getCPReportEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetCPReportUrl}/${page}/${pageSize}` : this.GetCPReportUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCPReportEndpoint(page, pageSize));
      }));
  }


  getCMReportEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetCMReportUrl}/${page}/${pageSize}` : this.GetCMReportUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCMReportEndpoint(page, pageSize));
      }));
  }

  getCampaignContactsEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.GetCampaignContactsUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCampaignContactsEndpoint());
      }));
  }

  getRetailsEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetRetailsUrl}/${page}/${pageSize}` : this.GetRetailsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRetailsEndpoint(page, pageSize));
      }));
  }

  getAddInfoDDsEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetAddInfoDDsUrl}/${page}/${pageSize}` : this.GetAddInfoDDsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAddInfoDDsEndpoint(page, pageSize));
      }));
  }

  GetAccountHubs<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetAccountHubsUrl}/${page}/${pageSize}` : this.GetAccountHubsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetAccountHubs(page, pageSize));
      }));
  }
  
  

  getCDReportEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.GetCDReportUrl}/${page}/${pageSize}` : this.GetCDReportUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCDReportEndpoint(page, pageSize));
      }));
  }

  CreateICD<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICD(userObject));
      }));
  }


  CreateICDStep2<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDStep2url, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep2(userObject));
      }));
  }


  CreateICDStep3<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDStep3url, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }

  CreateAddLoc<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDAddloc3url, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }

  CreateOffBoard<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateOffBoardurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }
  

  CreateCampChange<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateCampChange3url, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }

  CreateICDClose<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDCloseurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }
  ChangeOfficeInfo<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.ChangeOfficeInfourl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }
  HubMaintain<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.HubMaintainurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }
  CreateMoveLoc<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateMoveLocurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }

  CreateInactiveOff<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateInactiveOffurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }


  CreateReOpen<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateReOpencurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep3(userObject));
      }));
  }
  
  

  LoginSF<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.LoginSFurl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.LoginSF(userObject));
      }));
  }


  CreateICDStep4<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.CreateICDStep4url, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.CreateICDStep4(userObject));
      }));
  }
  getMasterConfigs<T>(types?: string): Observable<T> {
    const endpointUrl = types ? `${this.MasterConfigsurl}/${types}` : this.MasterConfigsurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getMasterConfigs(types));
      }));
  }


  getICD<T>(caseid?: string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetICDsurl}/${caseid}` : this.GetICDsurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getICD(caseid));
      }));
  }

  GetAccountReps<T>(name?: string,camp?:string): Observable<T> {
    const endpointUrl = name ? `${this.GetAccountRepsUrl}/${name}/${camp}` : this.GetAccountRepsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetAccountReps(name));
      }));
  }

  CheckDueDeligRequired<T>(poname?: string, camp?: string,ownername?: string): Observable<T> {
    const endpointUrl = poname ? `${this.GetCheckDueDeligRequiredUrl}/${poname}/${camp}/${ownername}` : this.GetAccountRepsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetAccountReps(poname));
      }));
  }


  ReSendEmail<T>(poname?: string): Observable<T> {
    const endpointUrl = poname ? `${this.GetReSendEmailUrl}/${poname}` : this.GetAccountRepsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetAccountReps(poname));
      }));
  }

  ResendEmailLog<T>(emailId?: string): Observable<T> {
    const endpointUrl = emailId ? `${this.ResendEmailLogUrl}/${emailId}` : this.ResendEmailLogUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.ResendEmailLog(emailId));
      }));
  }

  CheckDueDeligRequiredMyOwnOffice<T>(poname?: string, camp?: string, ownername?: string): Observable<T> {
    const endpointUrl = poname ? `${this.GetCheckDueDeligRequiredMyOwnOfficeUrl}/${poname}/${camp}/${ownername}` : this.GetAccountRepsUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetAccountReps(poname));
      }));
  }

  GetCaseData<T>(camp?: string, repid?:string): Observable<T> {
    const endpointUrl = camp ? `${this.GetCaseDataurl}/${camp}/${repid}` : this.GetCaseDataurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetCaseData(camp, repid));
      }));
  }

  checkTaxIdExists<T>(taxId: string): Observable<T> {
    const endpointUrl = `${this.CheckTaxIdUrl}/${encodeURIComponent(taxId)}`;
    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.checkTaxIdExists(taxId));
      }));
  }


  getOTP<T>(caseid?: string,otp?:string , step?:string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetOTPsurl}/${caseid}/${otp}/${step}` : this.GetOTPsurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOTP(caseid,otp,step));
      }));
  }

  getICDStep3<T>(caseid?: string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetICDStep3surl}/${caseid}` : this.GetICDStep3surl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getICDStep3(caseid));
      }));
  }


  getICDStep3byAcc<T>(caseid?: string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetICDStep3byAccsurl}/${caseid}` : this.GetICDStep3byAccsurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getICDStep3(caseid));
      }));
  }

  getICDStep3byAccJDE<T>(caseid?: string, dcode?: string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetICDStep3byAccsjdeurl}/${caseid}/${dcode}` : this.GetICDStep3byAccsjdeurl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getICDStep3(caseid));
      }));
  }

  

  getICDLocationsByAccount<T>(caseid?: string): Observable<T> {
    const endpointUrl = caseid ? `${this.GetICDLocationsByAccounturl}/${caseid}` : this.GetICDLocationsByAccounturl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getICDStep3(caseid));
      }));
  }

  GetUsers<T>(): Observable<T> {
    return this.http.get<T>(this.GetUsersUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.GetUsers());
      }));
  }

  SendComposedEmail<T>(emailData: any): Observable<T> {
    return this.http.post<T>(this.SendComposedEmailUrl, JSON.stringify(emailData), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.SendComposedEmail(emailData));
      }));
  }

  verifyDocumentEndpoint<T>(body: any): Observable<T> {
    return this.http.post<T>(this.DocumentVerifyUrl, JSON.stringify(body), this.requestHeaders).pipe<T>(
      catchError(error => {
        // Do not retry verification — throw so the component error handler shows advisory warning
        return throwError(() => error);
      }));
  }

  stageAttachmentEndpoint<T>(body: any): Observable<T> {
    // Do not retry — the component surfaces the real server error next to the field (FR5).
    return this.http.post<T>(this.StageAttachmentUrl, JSON.stringify(body), this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

  // Step 2 anonymous variant — posts to the [AllowAnonymous] SFStep2 endpoint.
  stageAttachmentStep2Endpoint<T>(body: any): Observable<T> {
    return this.http.post<T>(this.StageAttachmentStep2Url, JSON.stringify(body), this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

  // Feature 9 — Hub LT-Report CSV upload. No auto-retry: the server response (validation errors
  // or success summary) is shown to the hub, and retrying would create a duplicate submission.
  uploadHubReportEndpoint<T>(body: any): Observable<T> {
    return this.http.post<T>(this.HubReportUploadUrl, JSON.stringify(body), this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

  getHubReportContextEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.HubReportContextUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHubReportContextEndpoint());
      }));
  }

  getHubReportMissingEndpoint<T>(weekEnding?: string): Observable<T> {
    const endpointUrl = weekEnding ? `${this.HubReportMissingUrl}/${weekEnding}` : this.HubReportMissingUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHubReportMissingEndpoint(weekEnding));
      }));
  }

  getDashboardStatsEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.GetDashboardStatsUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDashboardStatsEndpoint());
      }));
  }

  getAddressChangeTasksEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.GetAddressChangeTasksUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAddressChangeTasksEndpoint());
      }));
  }

  getHelpfulContactsEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.HelpfulContactsUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHelpfulContactsEndpoint());
      }));
  }

  createHelpfulContactEndpoint<T>(contact: any): Observable<T> {
    return this.http.post<T>(this.HelpfulContactsUrl, JSON.stringify(contact), this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

  updateHelpfulContactEndpoint<T>(id: number, contact: any): Observable<T> {
    const url = `${this.HelpfulContactsUrl}/${id}`;
    return this.http.put<T>(url, JSON.stringify(contact), this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

  deleteHelpfulContactEndpoint<T>(id: number): Observable<T> {
    const url = `${this.HelpfulContactsUrl}/${id}`;
    return this.http.delete<T>(url, this.requestHeaders).pipe<T>(
      catchError(error => {
        return throwError(() => error);
      }));
  }

}
